<template>
  <div class="rootDiv">
    <header class="mint-header is-fixed" style="border-bottom: 1px solid gainsboro;background: white;">
      <div style="float: left;">
        <img src="../../../../assets/images/32/menuType.png" @click="showPopup"
             style="padding: 0;margin-top: 0.5rem;margin-right: 0.5rem;margin-left: 0.5rem" height="20"
             width="20"
             slot="icon" alt="">
        <img src="../../../../assets/images/32/change.png" @click="changePage()"
             style="margin-right:20px ;padding: 0;margin-top: 0.5rem" height="20"
             width="20"
             slot="icon" alt="">
      </div>
      <div style="width: 30rem;height: 32px;" class="mint-search searchstyle">
        <div class="mint-searchbar" style="padding: 0">
          <div class="mint-searchbar-inner">
            <i class="mintui mintui-search"/>
            <input type="search" placeholder="搜索" class="mint-searchbar-core" style="color: black" v-model="searchKey"/>
            <a class="mint-searchbar-cancel" style="display: none;">取消</a>
          </div>
          <div class="mint-search-list" style="display: none;">
            <div class="mint-search-list-warp"/>
          </div>
        </div>
      </div>
      <div style="float: left;">
        <img src="../../../../assets/images/32/search.png" @click="SearchStar()"
             style="margin-right:20px ;padding: 0;margin-top: 0.5rem" height="20"
             width="20"
             slot="icon" alt="">
      </div>
    </header>
    <div :style="classtest" style="margin-top: 45px">
      <div style="text-align: left;margin-left: 0.5rem;margin-top: 0.5rem;font-size: 0.8rem">
        <strong style="font-size: 0.8rem">条件筛选 >> </strong>
        <span>国籍：</span>
        <span style="color: #2986de">{{ selectedNation }}</span>
        <span> > 性别：</span>
        <span style="color: #2986de">{{ selectedSex }}</span>
        <span> > 排序：</span>
        <span style="color: #2986de">{{ selectedSort }}{{ selectedSortBy }}</span>
      </div>
      <Loadmore :bottom-method="loadBottom" :auto-fill="false" ref="loadmore">
        <ul v-for="item in starList" :key="item.cSRQNM" class="one">
          <li class="two">
            <div :style="{'float': 'left','padding': '0.5rem','min-height':imgHeight+70+'px'}"
                 @click="details(item.cSRQNM)">
              <img class="three" :src="item.zP" alt="" :width="imgWidth" :height="imgHeight">
              <br>
              <Span style="font-size: 1.2rem;color: #2986de">{{ item.xM | ellipsis(8) }}</Span>
              <img v-if="item.sRTS===0" src="../../../../assets/images/32/birthday.png" width="20" height="20"
                   alt=""/>
              <br>
              <Span style="font-size: 0.8rem">{{
                  item.gJ
                }}</Span>
              <br>
              <Span style="font-size: 0.8rem">{{
                  (item.nL + '岁') + (item.sG > 0 ? '-' + item.sG + 'cm' : '') + (item.tZ > 0 ? '-' + item.tZ + 'kg' : '') + (item.sRTS === 0 ? '' : '-' + item.sRTS + '天') | ellipsis(20)
                }}</Span>
              <br>
            </div>
          </li>
        </ul>
      </Loadmore>
    </div>
    <div>
      <span v-if="noMore">没有更多了...</span>
    </div>
    <Popup style="width: 90%;height: 90%;background-color: lightgrey;  overflow-y: scroll;"
           v-model="popupVisible"
           popup-transition="popup-fade">
      <div>
        <div style="background-color: #2986de;padding-bottom: 0.5rem;padding-top: 0.5rem">
          <span style="font-size: 1.6rem">条件筛选</span>
        </div>
        <div style="background-color: lightseagreen;">
          <span style="font-size: 1.2rem">国籍</span>
        </div>
        <div style="text-align: left;margin-top: 0.5rem">
          <Button round type="info" v-for="item in nationList" :key="item.gJ" class="nationButton"
                  @click="SelectNation(item.gJ)"
                  :style="{'background-color': !item.isSelected?'#FFFFFF':'lightseagreen','border-color': !item.isSelected?'#FFFFFF':'lightseagreen'}">
            {{ item.gJ }}
          </Button>
        </div>
        <div style="background-color: lightseagreen;margin-top: 0.5rem">
          <span style="font-size: 1.2rem">性别</span>
        </div>
        <div style="margin-top: 0.5rem">
          <Button v-for="item in sexList" :key="item.sex" round type="info" class="sexButton"
                  @click="SelectSex(item.sex)"
                  :style="{'background-color': !item.isSelected?'#FFFFFF':'lightseagreen','border-color': !item.isSelected?'#FFFFFF':'lightseagreen'}">
            {{ item.sex }}
          </Button>
        </div>
        <div style="background-color: lightseagreen;margin-top: 0.5rem">
          <span style="font-size: 1.2rem">排序</span>
        </div>
        <div style="margin-top: 0.5rem">
          <Button v-for="item in sortList" :key="item.sort" round type="info" class="sexButton"
                  @click="SelectSort(item.sort)"
                  :style="{'background-color': !item.isSelected?'#FFFFFF':'lightseagreen','border-color': !item.isSelected?'#FFFFFF':'lightseagreen'}">
            {{ item.sort }}
          </Button>
        </div>
        <div style="margin-top: 0.5rem">
          <Button v-for="item in sortByList" :key="item.sortBy" round type="info" class="sexButton"
                  @click="SelectSortBy(item.sortBy)"
                  :style="{'background-color': !item.isSelected?'#FFFFFF':'lightseagreen','border-color': !item.isSelected?'#FFFFFF':'lightseagreen'}">
            {{ item.sortBy }}
          </Button>
        </div>
        <div style="margin-top: 0.5rem;padding: 0.5rem">
          <Button type="primary" size="large" @click="ActionComfirm(true)"
                  style="background-color:#2986de;border-color: #2986de;color: black;height: 2.5rem;font-size: 1.4rem">
            确定
          </Button>
          <Button type="primary" size="large" @click="ActionComfirm(false)"
                  style="margin-top: 0.5rem;background-color:#2986de;border-color: #2986de;color: black;height: 2.5rem;font-size: 1.4rem">
            重置
          </Button>
        </div>
      </div>
    </Popup>
    <div class="empty-div" v-if="showEmptyImage">
      <img src="../../../../assets/images/no_data.png" alt=""/>
    </div>
  </div>
</template>

<script>
import {Indicator, Loadmore, Popup} from "mint-ui";
import {Button} from 'vant';
import 'vant/lib/button/index.css'

export default {
  name: "Recipe",
  filters: {
    ellipsis(value, lenth) {
      if (!value) return ''
      let len = 0
      for (let i = 0; i < value.length; i++) {
        if (value.charCodeAt(i) > 127 || value.charCodeAt(i) === 94) {
          len += 2;
        } else {
          len++;
        }
      }
      if (len > lenth) {
        return value.slice(0, lenth) + '...'
      }
      return value
    }
  },
  data() {
    return {
      showEmptyImage: false,
      nationList: [],
      starList: [],
      sexList: [
        {sex: '全部', isSelected: true},
        {sex: '男', isSelected: false},
        {sex: '女', isSelected: false}],
      sortList: [
        {sort: '生日', isSelected: true},
        {sort: '姓名', isSelected: false},
        {sort: '年龄', isSelected: false},
        {sort: '身高', isSelected: false},
        {sort: '体重', isSelected: false}],
      sortByList: [
        {sortBy: '升序', isSelected: true},
        {sortBy: '降序', isSelected: false}],
      popupVisible: false,
      imgWidth: document.documentElement.clientWidth * 0.5 - 18,
      imgHeight: (document.documentElement.clientWidth * 0.5 - 16) * 1.32,
      classtest:
          {
            overflow: 'scroll',
            height: (document.documentElement.clientHeight - 60).toString() + 'px',
          },
      noMore: false,
      pageSize: 30,
      pageIndex: 1,
      searchKey: null,
      selectedNation: '全部',
      selectedSex: '全部',
      selectedSort: '生日',
      selectedSortBy: '升序',
      token: localStorage.getItem('token'),
      yhnm: localStorage.getItem('yhnm'),
      getStarListUrl: '/api/star/getStarList',
      getNationListUrl: '/api/star/getNationList',
    }
  },
  components: {
    Loadmore, Popup, Button
  },
  mounted() {
    this.getStarList(false)
    this.getNationList()
  },
  methods: {
    SearchStar() {
      this.pageIndex = 1
      this.getStarList(false)
    },
    changePage() {
      let condition = {
        yhnm: this.yhnm,
        keyword: this.searchKey,
        sex: this.selectedSex,
        nation: this.selectedNation,
        sort: this.selectedSort,
        sortBy: this.selectedSortBy,
        pageIndex: 1,
        pageSize: this.pageSize * this.pageIndex,
      }
      localStorage.setItem("StarData", JSON.stringify(condition))
      this.$router.replace('m_star_birthday')
    },
    ActionComfirm(val) {
      if (!val) {
        this.nationList.forEach(item => {
          if (item.gJ === '全部')
            this.$set(item, 'isSelected', true)
          else
            this.$set(item, 'isSelected', false)
        })
        this.sexList.forEach(item => {
          if (item.sex === '全部')
            this.$set(item, 'isSelected', true)
          else
            this.$set(item, 'isSelected', false)
        })
        this.sortList.forEach(item => {
          if (item.sort === '姓名')
            this.$set(item, 'isSelected', true)
          else
            this.$set(item, 'isSelected', false)
        })
        this.sortByList.forEach(item => {
          if (item.sortBy === '升序')
            this.$set(item, 'isSelected', true)
          else
            this.$set(item, 'isSelected', false)
        })
        this.selectedNation = '全部'
        this.selectedSex = '全部'
        this.selectedSort = '生日'
        this.selectedSortBy = '升序'
      }
      this.pageIndex = 1
      this.getStarList(false)
      this.popupVisible = false
    },
    SelectSort(sort) {
      this.selectedSort = sort
      this.sortList.forEach(item => {
        if (item.sort === sort)
          this.$set(item, 'isSelected', true)
        else
          this.$set(item, 'isSelected', false)
      })
    },
    SelectSortBy(sortBy) {
      this.selectedSortBy = sortBy
      this.sortByList.forEach(item => {
        if (item.sortBy === sortBy)
          this.$set(item, 'isSelected', true)
        else
          this.$set(item, 'isSelected', false)
      })
    },
    SelectNation(nation) {
      this.selectedNation = nation
      this.nationList.forEach(item => {
        if (item.gJ === nation)
          this.$set(item, 'isSelected', true)
        else
          this.$set(item, 'isSelected', false)
      })
    },
    SelectSex(sex) {
      this.selectedSex = sex
      this.sexList.forEach(item => {
        if (item.sex === sex)
          this.$set(item, 'isSelected', true)
        else
          this.$set(item, 'isSelected', false)
      })
    },
    getNationList() {
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getNationListUrl,
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
            if (!response.data.result)
              that.$messagebox.alert(response.data.message)
            else {
              that.nationList = response.data['responseData']
              that.nationList.forEach(item => {
                if (item.gJ === '全部')
                  this.$set(item, 'isSelected', true)
                else
                  this.$set(item, 'isSelected', false)
              })
            }
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
    showPopup() {
      this.popupVisible = true
    },
    getStarList(isLoadmore) {
      Indicator.open({
        text: '数据加载中...',
        spinnerType: 'fading-circle'
      });
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getStarListUrl,
        params: {
          yhnm: that.yhnm,
          keyword: that.searchKey,
          sex: that.selectedSex,
          nation: that.selectedNation,
          sort: that.selectedSort,
          sortBy: that.selectedSortBy,
          pageIndex: that.pageIndex,
          pageSize: that.pageSize
        },
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
            Indicator.close()
            if (!response.data.result)
              that.$messagebox.alert(response.data.message)
            else {
              let responseData = response.data['responseData']
              let list = responseData['data']
              if (that.pageIndex === 1) {
                that.starList = list
              } else {
                that.starList = that.starList.concat(list)
              }
              that.showEmptyImage = that.starList.length <= 0;
              that.noMore = responseData['isLast'].toString() !== 'false';
            }
            if (isLoadmore)
              that.$refs.loadmore.onBottomLoaded();
          }
      ).catch(response => {
        Indicator.close()
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
        if (isLoadmore)
          that.$refs.loadmore.onBottomLoaded();
      })
    },
    loadBottom() {
      if (this.noMore === true) {
        this.$refs.loadmore.onBottomLoaded();
        return;
      }
      this.pageIndex++
      this.getStarList(true)
    },
    details(id) {
      this.$router.push({name: 'm_star_birthday_details', params: {id: id}})
    },
  },
}
</script>

<style lang="less" scoped>

.one {
  width: 100%;
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.right-menu {
  padding: 0;
}

.two {
  float: left;
}

.three {
  border-radius: 10px;
}

.nationButton {
  margin: 0.2rem;
  padding: 2px;
  width: 4.1rem;
  height: 2rem;
  background-color: #FFFFFF;
  border-color: #FFFFFF;
  color: black
}

.sexButton {
  margin: 0.2rem;
  padding: 2px;
  width: 4.1rem;
  height: 2rem;
  color: black
}

.rootDiv {
  margin-top: -0.5rem;
  margin-right: -0.5rem;
  margin-left: -0.5rem;
}

.empty-div {
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translate3d(-50%, -50%, 0);
}

.addbutton {
  background: lightseagreen;
}

.wrapper {
  overflow-y: scroll;
}

/deep/ .mint-loadmore-bottom {
  clear: both
}

/deep/ .mint-searchbar {
  padding: 1px;
  background-color: #dddddd;
}
</style>
